<template>
  <transition name="cookie-slide">
    <div
      class="cookie-consent"
      v-if="!DEDEcookies && Hidecookies == false"
      :key="componentKey"
    >
      <div class="cookie-icon">🍪</div>
      <div class="cookie-body">
        <p class="cookie-text">
          เว็บไซต์นี้ใช้คุกกี้เพื่อปรับปรุงประสบการณ์ของผู้ใช้
          การใช้เว็บไซต์ของเราแสดงว่าคุณยินยอมให้ใช้คุกกี้ทั้งหมดตามนโยบายคุกกี้ของเรา
          <button
            @click="showPolicyDialog = true" class="btn btn-link">
            นโยบายการใช้คุกกี้
          </button>
          <el-dialog
            v-model="showPolicyDialog"
            title="นโยบายการใช้คุกกี้"
            width="80%"
          >
            <iframe
              :src="`${publicPath}cookie`"
              style="width: 100%; height: 600px; border: none;"
            ></iframe>
          </el-dialog>
        </p>
        <div class="cookie-actions">
          <button class="cookie-btn cookie-btn--accept" @click="setCookies">
            ยอมรับทั้งหมด
          </button>
          <button class="cookie-btn cookie-btn--close" @click="closeCookies">
            ปิด
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: auto;
  max-width: 420px;
  width: calc(100% - 32px);
  color: #e0e0e0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px;
  font-size: 13px;
  line-height: 1.6;
  background: #1a1a2e;
  z-index: 9999;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.cookie-icon {
  font-size: 28px;
  flex-shrink: 0;
  margin-top: 2px;
}

.cookie-body {
  flex: 1;
  min-width: 0;
}

.cookie-text {
  margin: 0 0 14px 0;
  color: #b0b0c0;
  font-size: 13px;
}

.cookie-link {
  color: #7c8aff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.cookie-link:hover {
  color: #a0aaff;
  text-decoration: underline;
}

.cookie-actions {
  display: flex;
  gap: 8px;
}

.cookie-btn {
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.cookie-btn--accept {
  background: linear-gradient(135deg, #4caf50, #45a049);
  color: #fff;
}

.cookie-btn--accept:hover {
  background: linear-gradient(135deg, #5cbf60, #4fb853);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.cookie-btn--close {
  background: rgba(255, 255, 255, 0.08);
  color: #b0b0c0;
}

.cookie-btn--close:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

/* Slide-up animation */
.cookie-slide-enter-active {
  transition: all 0.4s ease-out;
}
.cookie-slide-leave-active {
  transition: all 0.3s ease-in;
}
.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Mobile: full-width bottom bar */
@media (max-width: 480px) {
  .cookie-consent {
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    width: 100%;
    border-radius: 16px 16px 0 0;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .cookie-icon {
    font-size: 24px;
  }

  .cookie-actions {
    width: 100%;
    justify-content: center;
  }

  .cookie-btn {
    flex: 1;
    padding: 10px 12px;
  }
}
</style>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useCookies } from "vue3-cookies";
export default defineComponent({
  name: "Cookies",
  props: {
    // logo: String
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLICPATH || "/",
    };
  },
  setup() {
    const componentKey = ref(0);
    const DEDEcookies = ref(false);
    const Hidecookies = ref(false);
    const { cookies } = useCookies();
    const showPolicyDialog = ref(false);
    onMounted(() => {
      if (cookies.get("DEDE-cookies")) {
        DEDEcookies.value = true;
      }
    });
    const setCookies = () => {
      cookies.set("DEDE-cookies", "YES");
      DEDEcookies.value = true;
      componentKey.value += 1;
    };
    const closeCookies = () => {
      Hidecookies.value = true;
      componentKey.value += 1;
    };

    return {
      cookies,
      setCookies,
      DEDEcookies,
      closeCookies,
      Hidecookies,
      componentKey,
      showPolicyDialog,
    };
  },
});
</script>
